import { createContext } from "react"

const BusinessTypesContext = createContext();

export default BusinessTypesContext;